module.exports = __webpack_public_path__ + "img/14.c1dc8cf2.png";